import React from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";
import { minDate } from "../../../Constants/Constants";

const UpdateProductDetailsModal = ({
  updateHandleChange,
  selectedRowsData,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const companyName = selectedRowsData.companyDetails?.company_name || "";
  const companyLocation = selectedRowsData.companyDetails?.location || "";
  const productName = selectedRowsData.productName?.size || "";
  const companyId = selectedRowsData.companyDetails?.id || "";
  const party = selectedRowsData?.partyName?.party_name || "";
  const material = selectedRowsData?.raw_material?.material_name || "";
  const materialId = selectedRowsData?.raw_material?.id || "";
  const partyId = selectedRowsData?.partyName?.id || "";

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateProduct = async (e) => {
    e.preventDefault();
    const { id, incoming_stock, quantity, date, product_name_id } =
      selectedRowsData;
    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        product_name_id: product_name_id,
        quantity,
        date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateProductModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Product Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update product Details</h4> */}
                    <form className="form-sample" onSubmit={updateProduct}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="name"
                              placeholder="company Name"
                              readOnly
                              value={`${companyName}, ${companyLocation}`}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="quantity">Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              name="quantity"
                              id="quantity"
                              placeholder="Quantity"
                              value={selectedRowsData.quantity}
                              onChange={updateHandleChange}
                              required
                              min="1"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Product">Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="product_name"
                              id="Product"
                              readOnly
                              value={productName}
                              onChange={updateHandleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="date"
                              readOnly
                              min={minDate}
                              max={new Date().toISOString().split("T")[0]}
                              value={selectedRowsData.date}
                              onChange={updateHandleChange}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateProduct}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProductDetailsModal;
